import { of } from 'rxjs'
import { map, catchError } from 'rxjs/operators'
import PromiseWorker from 'promise-worker'

class ActionWorker extends PromiseWorker {

  constructor () {
    super(...arguments)
    this.call('setCookie', document.cookie)
  }

  call (action, ...args) {
    return this.postMessage(JSON.stringify({
      action,
      args
    })).then(JSON.parse).then(({ ok, result, error }) => {
      if (!ok) {
        throw new Error(error)
      }
      return result
    })
  }
}

const encryptionWorker = new window.Worker(`${process.env.HASH}.cryptography.js`)
export const crypto = new ActionWorker(encryptionWorker)

export const encrypt = function (str) {
  return of(
    crypto.call('encrypt', str)
  )
}

export const decrypt = function (encrypted) {
  return of(
    crypto.call('decrypt', encrypted)
  )
}

export const exportKey = function () {
  return of(
    crypto.call('generateKey')
  )
}

export const testKey = function (key) {
  return of(
    crypto.call('unwrapKey', key)
  ).pipe(map(k => k !== null),catchError(e => of(false)))
}

export const listKeys = function () {
  return of(
    crypto.call('listKeys')
  )
}

export const exportKeys = function () {
  return of(
    crypto.call('exportKeys')
  )
}
